const state = {
  token: null,
  user_name: null,
  account_type: null,
  user_id: null,
  lang: "ar",
  langData: {},
  /** @type {'light' | 'dark'} */
  theme: "light",
}
export default state